module.exports = __webpack_public_path__ + "static/media/heart-empty-dark-outline.028e30e5.svg";